import React from 'react';
import { cx } from './cx';

export type Tone = 'ok' | 'warn' | 'danger' | 'neutral' | 'brand';

const tones: Record<Tone, string> = {
  ok: 'bg-ok-soft text-ok',
  warn: 'bg-warn-soft text-warn',
  danger: 'bg-danger-soft text-danger',
  neutral: 'bg-chip text-muted',
  brand: 'bg-brand-50 text-brand-800',
};

interface BadgeProps {
  tone?: Tone;
  children?: React.ReactNode;
  className?: string;
}

export const Badge = ({ tone = 'neutral', children, className }: BadgeProps) => (
  <span className={cx('inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold', tones[tone], className)}>
    <span className="h-1.5 w-1.5 rounded-full bg-current" aria-hidden="true" />
    {children}
  </span>
);

const STATUS_TONE: Record<string, Tone> = { active: 'ok', drafts: 'warn', draft: 'warn', closed: 'neutral' };
const STATUS_LABEL: Record<string, string> = { active: 'Active', drafts: 'Draft', draft: 'Draft', closed: 'Closed' };

/** Project status as stored by the current backend: active | drafts | closed (case-insensitive). */
export const StatusBadge = ({ status }: { status?: string | null }) => {
  const key = String(status || '').toLowerCase();
  return <Badge tone={STATUS_TONE[key] || 'neutral'}>{STATUS_LABEL[key] || status || 'Unknown'}</Badge>;
};
